export {
  socialIntegrationEmailParsingRuleApi,
  useLazySocialIntegrationEmailParsingRuleListQuery,
  useSocialIntegrationEmailParsingRuleListQuery,
  useSocialIntegrationEmailParsingRuleUpdateMutation,
} from './api';

export {
  SocialIntegrationEmailParsingRuleEndpoints,
  type ModelSocialIntegrationEmailParsingRule,
  type ModelSocialIntegrationEmailParsingRuleArray,
  type ModelSocialIntegrationEmailParsingRuleListResponse,
  type ModelSocialIntegrationEmailParsingRuleWithTags,
  type ModelTagIdName,
  type SocialIntegrationEmailParsingRuleListRequest,
  type SocialIntegrationEmailParsingRuleListResponseData,
  type SocialIntegrationEmailParsingRuleUpdateRequest,
  type SocialIntegrationEmailParsingRuleUpdateResponse,
} from './types';
